import { render, staticRenderFns } from "./calcdictGroupData.vue?vue&type=template&id=b86591b2&scoped=true&"
import script from "./calcdictGroupData.vue?vue&type=script&lang=js&"
export * from "./calcdictGroupData.vue?vue&type=script&lang=js&"
import style0 from "./calcdictGroupData.vue?vue&type=style&index=0&id=b86591b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b86591b2",
  null
  
)

export default component.exports